module.exports = __webpack_public_path__ + "static/media/convention_assistance_obseques.7513d626.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/common/convention_assistance_obseques.pdf
// module id = 307
// module chunks = 40